export const convertLocaleForIconName = (locale = '') => {
  if (!locale) return '';

  return locale
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.substring(1).toLowerCase())
    .join('');
};
